import React from "react"
import { Link } from "gatsby"
import { Badge } from "react-bootstrap"
import { colours } from "../../common/colours"
import useInboxMessageCount from "../booking/hooks/useInboxMessageCount"

const InboxLink = ({ navLink, handleClick, icon }) => {
  const total = useInboxMessageCount()
  return (
    <Link
      onClick={() => {
        if (handleClick && typeof handleClick === "function") {
          handleClick()
        }
      }}
      className={`${navLink ? "nav-link" : ""} position-relative ${
        total <= 0 ? "" : ""
      } `}
      to={"/booking/inbox"}
    >
      {icon ? icon : "Inbox"}
      {total > 0 ? (
        <Badge
          pill
          bg=""
          className="position-absolute translate-middle badge px-1 ms-2"
          style={{ backgroundColor: colours.blueLight }}
        >
          {total}
        </Badge>
      ) : null}
    </Link>
  )
}

export default InboxLink
